/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const SocialMediaFacebook16 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.023 16 6 9H3V6h3V4c0-2.7 1.672-4 4.08-4 1.153 0 2.144.086 2.433.124v2.821h-1.67c-1.31 0-1.563.623-1.563 1.536V6H13l-1 3H9.28v7z"
    />
  </svg>
);

export const __descriptor_SocialMediaFacebook = {
  name: "SocialMediaFacebook",
  instances: [{ size: 16, Component: SocialMediaFacebook16 }],
} as const;
